export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20fashion%20product%20flat%20lay%20with%20diverse%20items%20including%20premium%20sneakers%20leather%20bag%20gold%20watch%20silk%20scarf%20and%20sunglasses%20arranged%20artfully%20on%20light%20cream%20linen%20surface%2C%20soft%20diffused%20natural%20window%20light%20from%20upper%20left%2C%20warm%20neutral%20palette%2C%20elegant%20editorial%20product%20photography%2C%20rich%20textures%20visible%2C%20sophisticated%20lifestyle%20aesthetic&width=1800&height=900&seq=hero-main-bg-v9&orientation=landscape"
          alt="Superbuy Spreadsheet shopping resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-24 md:py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/30 mb-6 animate-fade-in">
            <span className="w-2 h-2 bg-accent-400 rounded-full"></span>
            <span className="text-background-50 text-xs font-medium tracking-wide">Updated 2026 Resources</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 animate-fade-in-up">
            Superbuy Spreadsheet
            <span className="block text-background-50/90 font-normal italic text-3xl md:text-4xl lg:text-5xl mt-2">
              Your Ultimate Resource Hub
            </span>
          </h1>

          <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg animate-fade-in-up animation-delay-200">
            Find, compare, and discover the best shopping resources in one place. Independent guides, curated product categories, and expert tutorials to help you shop smarter.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-400">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-3-line text-lg"></i>
              Superbuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-flashlight-line text-lg"></i>
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-5 mt-10 animate-fade-in-up animation-delay-600">
            {['Updated Resources', 'Independent Guide', 'Beginner Friendly', 'Safety Focused'].map((badge) => (
              <div key={badge} className="flex items-center gap-1.5 text-background-50/70 text-xs">
                <i className="ri-check-line text-accent-400 text-sm"></i>
                <span>{badge}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}